import React, { Component } from "react";
import styles from "../PricingWrapper.module.scss";
import SubNav from "../../../../shared/subnav/SubNav";
import Grid from "@material-ui/core/Grid";
import VehicleInfo from "../../../../shared/vehicleInfo/VehicleInfo";
import { vehicleInfo } from "./VehicleInfoMockData";
import BackToButton from "../../../../shared/backToButton/BackToButton";
import NscVehicles from "../nscVehicles/NscVehicles";
import NscOptions from "../nscOptions/NscOptions";
import { logMsg } from "../../../../common/Logger";
import {
  DEFAULT_VEHICLE,
  DEFAULT_YEAR,
  FEES_MAP,
  FUTURE_PRICING,
} from "../../../../common/Constants";
import DealerFees from "../dealerFees/DealerFees";
import PendingActionClient from "../../../../shared/clients/PendingActionClient";
import PricingClient from "../../../../shared/clients/PricingClient";
import UpperCaseText from "../../../../utils/UpperCaseText";
import { withTranslation } from "react-i18next";
import VehicleCatalogClient from "../../../../shared/clients/VehicleCatalogClient";
import {
  displayError,
  isUnknownError,
  PAGE_ERROR,
} from "../../../../errors/ErrorConstants";
import ModelDropDown from "./ModelDropDown";
import YearDropDown from "./YearDropDown";
import ExportAll from "./ExportAll";
import ListOfItems from "./ListOfItems";
import UiDateUtils from "../../../../utils/UiDateUtils";

class NscFuturePricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
      renderApp: false,
      modelData: null,
      hasError: [],
      buttonEnabled: false,
      selectedModel:
        this.props.location &&
        this.props.location.query &&
        this.props.location.query.model
          ? this.props.location.query.model
          : DEFAULT_VEHICLE,
      selectedYear:
        this.props.location &&
        this.props.location.query &&
        this.props.location.query.model
          ? this.props.location.query.modelYear
          : DEFAULT_YEAR,
      catalogIds: [],
      yearDropDownValues: [],
      optionsData: [],
      pricingData: [],
      feesData: [],
      released: [],
      priceUpdatesAvailable: [],
      futureEffectiveDate: null,
      //untilDate: null,
      futureIncentives: [],
    };
    this.currencySymbol =
      this.props.localizedInfo && this.props.localizedInfo.defaultCurrency
        ? this.props.localizedInfo.defaultCurrency.symbol
        : "NA";
    this.newVehicleLine = false;
    this.vehicleTitle = this.vehicleTitle.bind(this);
  }

  componentDidMount() {
    this.fetchVehicleLines();
  }

  onModelChange = (event) => {
    if (event) {
      event.preventDefault();
    }

    const maxYear = this.getYears(this.state.modelData, event.target.value);

    const catalogIds =
      this.state.modelData &&
      this.state.modelData
        .filter(
          (x) =>
            x.model === event.target.value &&
            x.year.toString() === maxYear.toString()
        )
        .map((model) => model.catalogId && model.catalogId.toString());
    this.setState(
      {
        selectedModel: event.target.value,
        renderApp: false,
        catalogIds: catalogIds,
        selectedTab: 0,
      },
      () => {
        this.fetchFutureNscPricing();
      }
    );
  };

  onYearChange = (event) => {
    const catalogIds = this.getCatalogIds(
      this.state.modelData,
      this.state.selectedModel,
      event.target.value
    );
    this.setState(
      {
        selectedYear: event.target.value,
        renderApp: false,
        optionsData: [],
        feesData: [],
        pricingData: [],
        released: [],
        catalogIds,
        selectedTab: 0,
      },
      () => {
        this.FuturePricing();
      }
    );
  };

  handleTabChange = (event, selectedTab) => {
    this.setState({ selectedTab });
  };

  fromPendingAction = () => {
    if (
      this.props.location &&
      this.props.location.actionName === FUTURE_PRICING
    ) {
      return true;
    }
  };

  getCatalogIds = (vehicleLines, selectedModel, selectedYear) => {
    const catalogIds = [];
    if (selectedYear !== null && selectedModel !== null)
      vehicleLines.forEach((vehicleLine) => {
        if (
          vehicleLine.model === selectedModel &&
          (selectedYear === "All" ||
            vehicleLine.year.toString() === selectedYear.toString())
        ) {
          catalogIds.push(vehicleLine.catalogId);
        }
      });
    return catalogIds;
  };

  fetchFutureNscPricing() {
    this.props.hideOrShow(true);
    const pricingData = [];
    const optionsData = [];
    const feesData = [];
    let released;
    let priceUpdatesAvailable;
    let futureEffectiveDate;
    //let untilDate;
    PricingClient.getFutureNscPricing(this.props.user, this.state.catalogIds)
      .then((res) => {
        if (res && res.length > 0) {
          res.forEach((data) => {
            data.result.products.forEach((entity) => {
              entity.vehiclePricingDetails.forEach((item) => {
                item["catalogId"] = entity.catalogId;
                item["vehicleLine"] = entity.vehicleLine;
                item["marketedSeries"] = entity.marketedSeries;
                item["marketedSeriesId"] = entity.marketedSeriesId;
                item["year"] = entity.year;
                item["ptvl"] = entity.ptvl;
                pricingData.push(item);
              });
            });
            optionsData.push(...data.result.options);
            feesData.push(...data.result.fees);
            released = data.result.released;
            priceUpdatesAvailable = data.result.priceUpdatesAvailable;
            futureEffectiveDate = data.result.futureEffectiveDate;
            //untilDate = data.result.untilDate;
          });
        }
        this.setState({
          pricingData,
          optionsData,
          feesData,
          released,
          priceUpdatesAvailable,
          futureEffectiveDate,
          //untilDate,
        });
        this.checkReleased();
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        if (
          this.state.pricingData.length > 0 &&
          this.state.catalogIds &&
          this.state.catalogIds.length > 0
        ) {
          this.fetchFutureIncentives(this.state.catalogIds);
        } else {
          this.setState({ renderApp: true });
        }

        this.props.hideOrShow(false);
      });
  }

  fetchFutureIncentives(catalogIds) {
    const checkedCatalogIds = [];
    this.props.hideOrShow(true);
    const vehicleInfo = [];
    this.state.pricingData.forEach((data) => {
      const vehicleLine = this.state.modelData.filter(
        (x) => x.catalogId === data.catalogId
      );
      const incentivesActive = vehicleLine && vehicleLine[0].incentivesActive;
      if (
        catalogIds.includes(data.catalogId) &&
        !checkedCatalogIds.includes(data.catalogId) &&
        incentivesActive
      ) {
        const item = {};
        item["vehicleLine"] = data.ptvl.substring(1);
        item["modelYear"] = data.year;
        item["catalogId"] = data.catalogId;
        vehicleInfo.push(item);
        checkedCatalogIds.push(data.catalogId);
      }
    });
    const requestData = {
      advanceDate: UiDateUtils.formatDateDDMMYYYYToYYYYMMDD(
        this.state.futureEffectiveDate,
        "/",
        "-"
      ),
      market: UpperCaseText(this.props.user.market),
      vehicleInfo: vehicleInfo,
    };
    PricingClient.getFutureIncentives(this.props.user, requestData)
      .then((res) => {
        this.setState({
          futureIncentives: res.futureIncentives,
        });
      })
      .catch((error) => {
        logMsg("reason", error);
        if (isUnknownError(error)) {
          this.setState({ hasError: [PAGE_ERROR] });
        }
      })
      .finally(() => {
        this.setState({ renderApp: true });
        this.props.hideOrShow(false);
      });
  }

  getDefaultModel = (vehicleLines) => {
    const models = vehicleLines.map((vehicleLine) => vehicleLine.model);
    return models.includes(this.state.selectedModel)
      ? this.state.selectedModel
      : models[0];
  };

  fetchVehicleLines() {
    this.props.hideOrShow(true);
    VehicleCatalogClient.getNscVehicleLines(this.props.user, false)
      .then((res) => {
        const selectedModel = this.getDefaultModel(res);
        const maxYear = this.getYears(
          res,
          selectedModel,
          this.fromPendingAction()
        );
        const catalogIds = res
          .filter(
            (x) =>
              x.model === this.state.selectedModel &&
              x.year.toString() === maxYear.toString()
          )
          .map((model) => model.catalogId.toString());
        this.setState({
          modelData: res,
          catalogIds,
        });
      })
      .catch((error) => {
        logMsg("reason", error);
        if (isUnknownError(error)) {
          this.setState({ hasError: [PAGE_ERROR] });
        }
      })
      .finally(() => {
        this.fetchFutureNscPricing();
        this.props.hideOrShow(false);
      });
  }

  checkReleased = () => {
    let buttonEnabled = false;
    if (!this.state.released) {
      this.setState({ buttonEnabled: true });
    } else {
      this.state.feesData &&
        this.state.feesData.forEach((fees) => {
          if (!fees.released) {
            buttonEnabled = true;
          }
        });
      this.state.pricingData &&
        this.state.pricingData.forEach((pricingRow) => {
          if (!pricingRow.released) {
            this.newVehicleLine = true;
            buttonEnabled = true;
          }
        });
      this.setState({ buttonEnabled });
    }
  };

  getYears = (data, selectedModel, fromPA) => {
    const years =
      data &&
      data
        .filter((x) => x.model === selectedModel)
        .map((model) => model.year.toString());

    const maxYear = Math.max.apply(Math, years);

    this.setState({
      yearDropDownValues: years,
      selectedYear: fromPA
        ? this.props.location.query && this.props.location.query.modelYear
        : years && maxYear,
    });

    return maxYear;
  };

  constructTabs() {
    return [
      {
        menuName: this.props.t("CurrentPricing.dealerFees"),
        enabled: true,
        id: "dealerFees",
      },
      {
        menuName: this.props.t("CurrentPricing.vehicles"),
        enabled: true,
        id: "vehicles",
      },
      {
        menuName: this.props.t("CurrentPricing.options"),
        enabled: true,
        id: "options",
      },
    ];
  }

  saveResponseBody = () => {
    const pricingData = [];
    const feesData = [];
    if (!this.state.released) {
      this.state.pricingData.forEach((item) => {
        pricingData.push(item);
      });
      return {
        pricing: pricingData,
        options: this.state.optionsData,
        fees: this.state.feesData,
      };
    } else {
      this.state.pricingData.forEach((item) => {
        if (!item.released) {
          pricingData.push(item);
        }
      });
      this.state.feesData.forEach((fees) => {
        if (!fees.released) {
          feesData.push(fees);
        }
      });
      return {
        pricing: pricingData,
        fees: feesData,
      };
    }
  };

  saveNscPricing = () => {
    const requestData = this.saveResponseBody();
    if (
      (requestData.pricing && requestData.pricing.length > 0) ||
      (requestData.fees && requestData.fees.length > 0) ||
      (requestData.options && requestData.options.length > 0)
    ) {
      this.props.hideOrShow(true);
      this.setState({ renderApp: false });
      PricingClient.saveNscPricingCall(this.props.user, requestData)
        .then(() => {
          //this.removePricingPendingAction(); *** GJV - No NSC PendingAction to remove
        })
        .catch((err) => {
          logMsg("error", err);
        })
        .finally(() => {
          this.fetchFutureNscPricing();
          this.props.hideOrShow(false);
        });
    }
  };

  removePricingPendingAction = () => {
    const vehicleLines =
      this.state.modelData &&
      this.state.modelData
        .filter(
          (vehicleInfo) =>
            (this.state.selectedYear !== "All" &&
              vehicleInfo.model === this.state.selectedModel &&
              Number(vehicleInfo.year) === Number(this.state.selectedYear)) ||
            (this.state.selectedYear === "All" &&
              vehicleInfo.model === this.state.selectedModel)
        )
        .map((vehicleInfo) => vehicleInfo.vehicleLine);

    PendingActionClient.removeNscPendingAction(
      this.props.user,
      FUTURE_PRICING,
      vehicleLines
    );
  };

  getSubHeader = () => {
    return (
      <div className={`${styles.left} pagePaddingLeft pagePaddingBottom`}>
        {this.state.selectedTab === 0 ? (
          <div className={styles.dealerTrans}>
            <p>{this.props.t("DealerFees.subHeader")} </p>
          </div>
        ) : this.state.selectedTab === 1 ? (
          <>
            <div className={styles.dealerTrans}>
              {this.props.t("DealerVehicles.subheader1")}
            </div>
            <div className={styles.equation}>
              {this.props.t("DealerVehicles.rrp")}{" "}
              <span className={styles.minus}> &#8722; </span>{" "}
              {this.props.t("DealerVehicles.variableMarketingOffer")}
              <span className={styles.plus}> &#43;/&#8722; </span>{" "}
              {this.props.t("DealerVehicles.dealerAdjustment")}
              <span className={styles.equal}> &#61; </span>{" "}
              {this.props.t("DealerVehicles.vehicle1")}
            </div>
            <div className={styles.equation}>
              {this.props.t("DealerVehicles.vehicle2")}
              <span className={styles.plus}> &#43; </span>
              {this.props.t("DealerVehicles.dealerFees")}{" "}
              <span className={styles.equal}> &#61; </span>{" "}
              {this.props.t("DealerVehicles.transactionPrice")}
            </div>
          </>
        ) : (
          <div className={styles.dealerTrans}>
            <p>{this.props.t("DealerVehicles.setAccessoriesPricing")}</p>
          </div>
        )}
        <div className={styles.modelDiv}>
          <div className={styles.dropdownContainer}>
            <Grid item md={3} xs={4}>
              <div className={styles.subTitle}>
                {this.props.t("NamePlate.model")}
              </div>
              <ModelDropDown
                {...this.props}
                modelData={this.state.modelData}
                selectedModel={this.state.selectedModel}
                modelDropDownValues={this.state.modelDropDownValues}
                updateModel={this.onModelChange}
              />
            </Grid>

            <Grid item md={3} xs={4}>
              <div className={styles.subTitle}>
                {this.props.t("NamePlate.modelYear")}
              </div>
              <YearDropDown
                {...this.props}
                yearValues={this.state.yearDropDownValues}
                updateYear={this.onYearChange}
                selectedYear={this.state.selectedYear}
                showAll={true}
              />
            </Grid>
            <Grid item md={5} xs={3} />
            <Grid item md={1} xs={1} className={styles.exportAllDiv}>
              <ExportAll
                {...this.props}
                feesData={this.state.feesData}
                pricingData={this.state.pricingData}
                optionsData={this.state.optionsData}
                selectedModel={this.state.selectedModel}
                selectedYear={this.state.selectedYear}
                futureEffectiveDate={this.state.futureEffectiveDate}
              />
            </Grid>
          </div>
        </div>
      </div>
    );
  };

  vehicleTitle() {
    return (
      <Grid className={styles.infoBar} container>
        <Grid item xs={6}>
          <VehicleInfo
            vehicleTitle={vehicleInfo.vehicleTitle}
            year={vehicleInfo.year}
          />
        </Grid>
      </Grid>
    );
  }

  getSubNav = () => {
    return (
      <div className={styles.left}>
        <SubNav
          {...this.props}
          title={this.props.t("DealerVehicles.futurePricing")}
          subTitle={this.vehicleTitle}
          renderSubHeader={true}
          subHeader={this.getSubHeader}
          selectedTab={this.state.selectedTab}
          action={this.handleTabChange}
          tabs={this.constructTabs()}
        />
      </div>
    );
  };

  getListOfItems = () => {
    return (
      <ListOfItems
        selectedTab={this.state.selectedTab}
        rowEditedCheckbox={[]}
        newVehiclesReleasedList={[]}
        feesData={this.state.feesData}
        rowOptionsEditedCheckbox={[]}
        newOptionsReleasedList={[]}
        optionsData={this.state.optionsData}
        rowEditSaved={[]}
        futureEffectiveDate={this.state.futureEffectiveDate}
      />
    );
  };

  render() {
    if (displayError(this.state.hasError))
      throw new Error(this.state.hasError[0]);
    return (
      this.state.renderApp && (
        <div className="pageWrapper">
          <BackToButton
            backToUrl="/pricing"
            display={this.props.t("PricingWrapper.backToPricing")}
          />
          {this.getSubNav()}
          {this.getListOfItems()}
          {this.state.selectedTab === 0 ? (
            <DealerFees
              {...this.props}
              handleTabChange={this.handleTabChange}
              released={!this.state.buttonEnabled}
              priceUpdatesAvailable={this.state.priceUpdatesAvailable}
              currencySymbol={this.currencySymbol}
              feesData={this.state.feesData}
              catalogIds={this.state.catalogIds}
            />
          ) : this.state.selectedTab === 1 ? (
            <NscVehicles
              {...this.props}
              handleTabChange={this.handleTabChange}
              futureIncentives={this.state.futureIncentives}
              released={!this.state.buttonEnabled}
              feesData={this.state.feesData}
              pricingData={this.state.pricingData}
              priceUpdatesAvailable={this.state.priceUpdatesAvailable}
              currencySymbol={this.currencySymbol}
              fees={FEES_MAP[UpperCaseText(this.props.user.market)]}
              catalogIds={this.state.catalogIds}
            />
          ) : (
            <NscOptions
              {...this.props}
              isDisabled={true}
              savePricing={this.saveNscPricing}
              released={!this.state.buttonEnabled}
              options={this.state.optionsData}
              priceUpdatesAvailable={this.state.priceUpdatesAvailable}
              currencySymbol={this.currencySymbol}
              catalogIds={this.state.catalogIds}
            />
          )}
        </div>
      )
    );
  }
}

export default withTranslation("emp")(NscFuturePricing);
